import LoadingSquare from "shared/components/loading/LoadingSquare.js";
import PopupAddTeam from "shared/components/popups/PopupAddTeam.js";
import PopupPremiumInfo from "shared/components/popups/PopupPremiumInfo.js";
import PopupEditTeam from "shared/components/popups/PopupEditTeam.js";
import { isUserPremium } from "shared/utils/user.js";
import { getSquadWarnings } from "shared/utils/squad.js";
import "./ControllerSelector.css";

export const ControllerTeamsAddButton = ({ teams, user, fetchTeams }) => (
  <div className="d-flex flex-shrink-0">
    {!isUserPremium(user) && teams && teams.length >= 3 ? (
      <PopupPremiumInfo
        trigger={
          <button
            type="button"
            className="btn btn-sm d-flex flex-column align-items-center justify-content-center m-0 premium-background"
            style={{ minWidth: 30, lineHeight: 1 }}
            title="Premium required"
            aria-label="Premium required to add a team"
          >
            <i className="bi bi-lock-fill"></i>
            {teams && <span style={{ fontSize: "10px" }}>({teams.length}/3)</span>}
          </button>
        }
      />
    ) : (
      <PopupAddTeam
        trigger={
          <button
            type="button"
            className="btn btn-sm d-flex flex-column align-items-center justify-content-center m-0 primary-color-background text-white"
            style={{ minWidth: 30, lineHeight: 1 }}
            title="Add Team"
            aria-label="Add team"
          >
            <i className="bi bi-plus"></i>
            {!isUserPremium(user) && teams && <span style={{ fontSize: "10px" }}>({teams.length}/3)</span>}
          </button>
        }
        onConfirm={fetchTeams}
      />
    )}
  </div>
);

const ControllerTeams = ({
  onSelect,
  onMove,
  teams,
  selectedTeamId,
  fetchTeams,
  user,
  notes,
  hideAddButton = false,
}) => {
  return (
    <div className="controller-selector d-flex flex-row align-items-start w-100">
      {!hideAddButton && (
        <div className="controller-selector-add">
          <ControllerTeamsAddButton teams={teams} user={user} fetchTeams={fetchTeams} />
        </div>
      )}

      <div className="controller-selector-items d-flex flex-row align-items-stretch">
        {teams ? (
          teams.map((p, index) => {
            const teamNotesCount = notes?.filter((note) => note.team.id === p.id).length || 0;
            const teamWarningsCount = getSquadWarnings(p, teams).length;

            return (
              <div
                key={p.id}
                className="controller-selector-item Item d-flex align-items-stretch"
                style={{
                  minWidth: 0,
                  padding: 0,
                  borderLeft: selectedTeamId === p.id ? "3px solid #f86285" : "3px solid transparent",
                  backgroundColor: selectedTeamId === p.id ? "rgba(248, 98, 133, 0.12)" : undefined,
                }}
              >
                <div
                  onClick={() => onSelect(p.id)}
                  className="position-relative d-flex flex-column justify-content-center ps-2"
                  style={{
                    cursor: selectedTeamId === p.id ? "default" : "pointer",
                    minHeight: 60,
                    minWidth: 0,
                    flex: "1 1 0%",
                    opacity: "1 !important",
                    fontWeight: "bold",
                    fontSize: 16,
                    lineHeight: 1,
                  }}
                >
                  <div className="text-truncate w-100" title={p.name}>
                    {p.name}
                  </div>
                  <div
                    className="w-100 text-truncate mt-1"
                    style={{ fontSize: 10, opacity: 0.7, whiteSpace: "nowrap" }}
                  >
                    {p.formation || "No formation"}
                  </div>
                  <div
                    className="w-100 text-truncate mt-1"
                    style={{ fontSize: 10, opacity: 0.7, whiteSpace: "nowrap" }}
                  >
                    {p.teamMembers?.length || 0} {p.teamMembers?.length === 1 ? "player" : "players"}
                  </div>
                  {(teamNotesCount > 0 || teamWarningsCount > 0) && (
                    <div
                      className="d-flex align-items-center gap-2 mt-1"
                      style={{ fontSize: 10, whiteSpace: "nowrap" }}
                    >
                      {teamNotesCount > 0 && (
                        <span className="text-yellow">
                          <i className="bi bi-sticky-fill me-1" />
                          {teamNotesCount}
                        </span>
                      )}
                      {teamWarningsCount > 0 && (
                        <span className="text-warning">
                          <i className="bi bi-exclamation-triangle-fill me-1" />
                          {teamWarningsCount}
                        </span>
                      )}
                    </div>
                  )}
                </div>

                <div className="d-flex flex-column align-items-center justify-content-around flex-shrink-0 px-1">
                  <PopupEditTeam
                    team={p}
                    trigger={
                      <button className="btn btn-sm text-main text-xs p-0" aria-label={`Edit ${p.name}`}>
                        <i className="bi bi-pencil-square" />
                      </button>
                    }
                    onClose={fetchTeams}
                    onUpdate={fetchTeams}
                  />
                  {/* Up caret */}
                  <button
                    className="btn btn-sm p-0"
                    style={{
                      color: "#f86285",
                      opacity: index === 0 ? 0.3 : 1,
                      borderRadius: "50%",
                      width: 20,
                      height: 20,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: index === 0 ? "not-allowed" : "pointer",
                    }}
                    disabled={index === 0}
                    onClick={() => onMove(p.id, index - 1)}
                  >
                    <i className="bi bi-caret-up-fill d-none d-md-block"></i>
                    <i className="bi bi-caret-left-fill d-block d-md-none"></i>
                  </button>

                  <button
                    className="btn btn-sm p-0"
                    style={{
                      color: "#f86285",
                      opacity: index === teams.length - 1 ? 0.3 : 1,
                      borderRadius: "50%",
                      width: 20,
                      height: 20,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: index === teams.length - 1 ? "not-allowed" : "pointer",
                    }}
                    disabled={index === teams.length - 1}
                    onClick={() => onMove(p.id, index + 1)}
                  >
                    <i className="bi bi-caret-down-fill d-none d-md-block"></i>
                    <i className="bi bi-caret-right-fill d-block d-md-none"></i>
                  </button>
                </div>
              </div>
            );
          })
        ) : (
          <div className="controller-selector-loading">
            <LoadingSquare height="60px" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ControllerTeams;
